import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { FluentProvider, Spinner } from '@fluentui/react-components'
import { appTheme } from './lib/theme'
import { bootstrap } from './api/client'
import App from './App.tsx'

const root = createRoot(document.getElementById('root')!)

// Read the runtime configuration and complete sign-in before the app renders —
// nothing in the shell has to cope with "not signed in yet". A failure here is
// terminal and says so: there is no usable read-only mode behind it.
root.render(
  <StrictMode>
    <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner label="Signing in…" />
      </div>
    </FluentProvider>
  </StrictMode>,
)

bootstrap().then(
  () => {
    root.render(
      <StrictMode>
        <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
          <App />
        </FluentProvider>
      </StrictMode>,
    )
  },
  (e: unknown) => {
    const message = e instanceof Error ? e.message : String(e)
    root.render(
      <StrictMode>
        <FluentProvider theme={appTheme} style={{ minHeight: '100vh' }}>
          <div style={{ padding: 32, maxWidth: 640 }}>
            <h2>Accounts Payable could not start</h2>
            <p>{message}</p>
            <p>Reload the page. If it keeps happening, tell the administrator what this said.</p>
          </div>
        </FluentProvider>
      </StrictMode>,
    )
  },
)
